import { passThroughAxios } from './passThrough.axios'

export default {
  getAllFaqs() {
    return passThroughAxios.get('faq')
  },
  createFaq(payload) {
    return passThroughAxios.post('faq', payload)
  },
  updateFaq(id, payload) {
    return passThroughAxios.put(`faq/${id}`, payload)
  },
  deleteFaq(id) {
    return passThroughAxios.delete(`faq/${id}`)
  },
}
